var app = angular.module('leonardo');

var ClientInstanceController = function ($state, $scope, $rootScope, $element, whiteLabelObj, NotificationService) {

  $scope.reactSubmissionCallbackError = function (callback) {
    if (callback && callback.response && callback.response.data) {
      NotificationService.error(callback.response.data);
    }
  };

  $rootScope.loadReact({
    selector: '#white-label-form',
    $element,
    component: window.oldReactComponent.WhiteLabel.DetailPage,
    data: {
      id: whiteLabelObj,
      onSubmit: function () {
        $state.go('client-instances');
        window.oldReduxStore.dispatch(window.oldReduxActions.resetConfiguration());
      },
      onCancel: function () {
        $state.go('client-instances');
        window.oldReduxStore.dispatch(window.oldReduxActions.resetConfiguration());
      },
      reactSubmissionCallbackError: $scope.reactSubmissionCallbackError
    }
  });
};

app.controller('ClientInstanceController', ['$state', '$scope', '$rootScope', '$element', 'whiteLabelObj', 'NotificationService', ClientInstanceController]);
